export default {"src":"https://cdn.jetlend.ru/_next/static/media/arrow-more.29609b88.svg","height":12,"width":18,"blurWidth":0,"blurHeight":0};